import _default3 from 'nanoutils/lib/clone';
import _default2 from 'nanoutils/lib/mapObjIndexed';
import _default from 'nanoutils/lib/mergeWith';
import defaults from './defaults';

import { normalizeOptions } from './normalize';

var mergers = {
  adapter: function adapter(from, to) {
    return to || from;
  },

  hooks: _default(function (from, to) {
    return (from || []).concat(to);
  }),

  meta: _default(function (from, to) {
    return to;
  })
};

var createMergeReducer = function createMergeReducer(cbs) {
  return function (res, cur) {
    return Object.assign(res, _default2(function (val, key) {
      return cbs[key] ? cbs[key](res[key], val) : val;
    }, cur));
  };
};

export var mergeOptions = function mergeOptions(opts) {
  opts = opts.map(function (opt) {
    return normalizeOptions(typeof opt === 'function' ? opt() : opt);
  });
  var def = _default3(defaults);
  var reducer = createMergeReducer(mergers);

  var newOptions = opts.reduce(reducer, def);
  var payloadMerger = newOptions.adapter && newOptions.adapter.merge || Object.assign;
  newOptions.payload = opts.reduce(function (res, cur) {
    return payloadMerger(res, cur.payload);
  }, {});
  return newOptions;
};